import { inject } from 'vue'
import { CanKey } from '@/config/setup/plugins/can/index.ts'

export function useCan() {
  const can = inject(CanKey)
  if (!can) {
    throw new Error('$can function is not provided')
  }
  return {
    can,
  }
}
